/**
 * @generated SignedSource<<79ac073a452ca6cb9a0b603a6cd7dd8d>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  /** AppStorageEntityValue */
  AppStorageEntityValue: {
    input: any;
    output: any;
  };
  /** AppStoredEntityFieldValue */
  AppStoredCustomEntityFieldValue: {
    input: any;
    output: any;
  };
  /** AppStoredEntityFieldValue */
  AppStoredEntityFieldValue: {
    input: any;
    output: any;
  };
  /** A scalar that can represent arbitrary-precision signed decimal numbers based on the JVMs [BigDecimal](https://docs.oracle.com/javase/8/docs/api/java/math/BigDecimal.html) */
  BigDecimal: {
    input: any;
    output: any;
  };
  /** Supported colors in the Palette */
  CardPaletteColor: {
    input: any;
    output: any;
  };
  /** CardTypeHierarchyLevelType */
  CardTypeHierarchyLevelType: {
    input: any;
    output: any;
  };
  /** A date scalar that accepts string values that are in yyyy-mm-dd format */
  Date: {
    input: any;
    output: any;
  };
  /** A scalar representing a specific point in time. */
  DateTime: {
    input: Date;
    output: Date;
  };
  /**
   * A scalar that enables us to spike [3D](https://relay.dev/docs/glossary/#3d) aka data-driven dependencies
   * This scalar is a requirement for using @match and @module directive supported by Relay GraphQL client
   * Please talk to #uip-app-framework before using this.
   * The definition of the scalar is yet to be decided based on spike insights.
   * To learn about current state see https://go.atlassian.com/JSDependency
   * DO NOT USE: Platform teams are iterating on the final shape of data returned
   */
  JSDependency: {
    input: any;
    output: any;
  };
  /**
   * The `JSON` scalar type represents JSON values as specified
   * by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).
   *
   * Note to schema designers - use this scalar with caution as the resultant data becomes untyped
   * from a consumers point of view.  There are legitimate use cases for this scalar type
   * but it SHOULD not be a common scalar.
   */
  JSON: {
    input: {
      [key: string]: any;
    };
    output: {
      [key: string]: any;
    };
  };
  /** A scalar that is a 64-bit signed Java primitive data type. Its range is -2^63 to 2^63 – 1 */
  Long: {
    input: number;
    output: number;
  };
  /** MercuryJSONString */
  MercuryJSONString: {
    input: any;
    output: any;
  };
  /** SoftwareBoardFeatureKey */
  SoftwareBoardFeatureKey: {
    input: any;
    output: any;
  };
  /** SoftwareBoardPermission */
  SoftwareBoardPermission: {
    input: any;
    output: any;
  };
  /** SprintScopeChangeEventType */
  SprintScopeChangeEventType: {
    input: any;
    output: any;
  };
  /**
   * A unique short string that can be used to fetch a board, card, etc. It's
   * usually used as a part of the entity URL. In some cases can be used as
   * as the ID.
   */
  TrelloShortLink: {
    input: any;
    output: any;
  };
  /** An URL scalar that accepts string values like [https://www.w3.org/Addressing/URL/url-spec.txt]( https://www.w3.org/Addressing/URL/url-spec.txt) */
  URL: {
    input: any;
    output: any;
  };
  /** UUID */
  UUID: {
    input: any;
    output: any;
  };
}
export enum ConfluenceContentType {
  ATTACHMENT = "ATTACHMENT",
  BLOG_POST = "BLOG_POST",
  COMMENT = "COMMENT",
  PAGE = "PAGE",
  WHITEBOARD = "WHITEBOARD",
}
export enum ConfluencePageSubType {
  LIVE = "LIVE",
}
/** Metadata on any analytics related fields, these do not affect the search */
export interface SearchAnalyticsInput {
  queryVersion?: InputMaybe<Scalars["Int"]["input"]>;
  /** A unique identifier for correlating user activity within a product session. */
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
  searchSessionId?: InputMaybe<Scalars["String"]["input"]>;
  searchReferrerId?: InputMaybe<Scalars["String"]["input"]>;
  /** The product which is running the experience e.g. confluence. */
  sourceProduct?: InputMaybe<Scalars["String"]["input"]>;
}
export interface SearchBoardFilter {
  projectARI?: InputMaybe<Scalars["ID"]["input"]>;
  userARI?: InputMaybe<Scalars["ID"]["input"]>;
  negateProjectFilter?: InputMaybe<Scalars["Boolean"]["input"]>;
}
export interface SearchCommonFilter {
  /** Search for only entities that have match the date range for the specified field */
  range?: InputMaybe<SearchCommonRangeFilter>;
  /** 1P AccountIds of the users. */
  contributorsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
}
export interface SearchCommonRangeFilter {
  /** Last modified date filter */
  lastModified?: InputMaybe<SearchCommonRangeFilterFields>;
  /** Created date filter */
  created?: InputMaybe<SearchCommonRangeFilterFields>;
}
export interface SearchCommonRangeFilterFields {
  /** Specify the timestamp that the field should be greater than */
  gt?: InputMaybe<Scalars["String"]["input"]>;
  /** Specify the timestamp that the field should be less than */
  lt?: InputMaybe<Scalars["String"]["input"]>;
}
export enum SearchConfluenceDocumentStatus {
  CURRENT = "CURRENT",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
}
export interface SearchConfluenceFilter {
  /** Space keys from which the results are desired. */
  spacesFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** AccountIds of the users. */
  contributorsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** AccountIds of the users. */
  creatorsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Labels which must be present on the page or blogpost. */
  labelsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Id of the pages which must be parent of the result. */
  ancestorIdsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
  range?: InputMaybe<Array<InputMaybe<SearchConfluenceRangeFilter>>>;
  containerStatus?: InputMaybe<Array<InputMaybe<SearchContainerStatus>>>;
  /** Confluence document status */
  contentStatuses?: InputMaybe<Array<SearchConfluenceDocumentStatus>>;
  /** Search for only entities that have a title that contains the given query */
  titleMatchOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Search for pages or blogposts with a specific page status */
  pageStatus?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search for Verified pages or blogposts */
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Space or Page ARI under which the search will have to be made. Includes the space or page itself. Maps to Containers filter. */
  containerARIs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search for pages owned by particular users. The values should be Atlassian Account IDs. */
  owners?: InputMaybe<Array<Scalars["String"]["input"]>>;
}
export enum SearchConfluenceRangeField {
  LASTMODIFIED = "LASTMODIFIED",
  CREATED = "CREATED",
}
export interface SearchConfluenceRangeFilter {
  /** The field to use to calculate the range */
  field: SearchConfluenceRangeField;
  /** Specify the timestamp that the field should be greater than */
  gt?: InputMaybe<Scalars["String"]["input"]>;
  /** Specify the timestamp that the field should be less than */
  lt?: InputMaybe<Scalars["String"]["input"]>;
}
export enum SearchContainerStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
}
/** Context for the search experiment */
export interface SearchExperimentContextInput {
  /** experimentId to override the default experimentId for scraping purposes */
  experimentId?: InputMaybe<Scalars["String"]["input"]>;
  /** Context for Aggregator's experimentation, including L3 and pre-query phase */
  experimentLayers?: InputMaybe<Array<InputMaybe<SearchExperimentLayer>>>;
}
export interface SearchExperimentLayer {
  /** ID for the Statsig layer */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** List of layers defined for each 1P and 3P product */
  definitions?: InputMaybe<Array<InputMaybe<SearchLayerDefinition>>>;
}
export interface SearchExternalContainerFilter {
  /** The container type */
  type: Scalars["String"]["input"];
  /** The list of containers */
  values: Array<Scalars["String"]["input"]>;
}
export interface SearchExternalContentFormatFilter {
  /** The content format type */
  type: Scalars["String"]["input"];
  /** The content formats */
  values: Array<Scalars["String"]["input"]>;
}
export interface SearchExternalDepthFilter {
  /** The depth type */
  type: Scalars["String"]["input"];
  /** The depth values */
  depth: Scalars["Int"]["input"];
}
export interface SearchExternalFilter {
  /** The list of containers */
  containers?: InputMaybe<Array<InputMaybe<SearchExternalContainerFilter>>>;
  /** The external content format filters */
  contentFormats?: InputMaybe<
    Array<InputMaybe<SearchExternalContentFormatFilter>>
  >;
  /** The depth of search */
  depth?: InputMaybe<Array<InputMaybe<SearchExternalDepthFilter>>>;
}
/** Filters to apply to a search */
export interface SearchFilterInput {
  /** ATI strings of which entities to search for */
  entities: Array<Scalars["String"]["input"]>;
  /** ARIs of which workspaces, cloudIds or orgs to search in */
  locations: Array<Scalars["String"]["input"]>;
  /** Common filters that apply to all products */
  commonFilters?: InputMaybe<SearchCommonFilter>;
  /** Confluence specific filters */
  confluenceFilters?: InputMaybe<SearchConfluenceFilter>;
  /** Jira Board filters */
  jiraFilters?: InputMaybe<SearchJiraFilter>;
  /** Mercury filters */
  mercuryFilters?: InputMaybe<SearchMercuryFilter>;
  /** Trello filters */
  trelloFilters?: InputMaybe<SearchTrelloFilter>;
  /** External filters */
  externalFilters?: InputMaybe<SearchExternalFilter>;
  /** Third party search filters */
  thirdPartyFilters?: InputMaybe<SearchThirdPartyFilter>;
}
export enum SearchIssueStatusCategory {
  OPEN = "OPEN",
  DONE = "DONE",
}
export interface SearchJiraFilter {
  /**  boardFilter can have at most one element only - multiple project ARI's to filter by are not supported */
  boardFilter?: InputMaybe<SearchBoardFilter>;
  projectFilter?: InputMaybe<SearchJiraProjectFilter>;
  issueFilter?: InputMaybe<SearchJiraIssueFilter>;
}
export interface SearchJiraIssueFilter {
  /** Account ARIs of the issue assignees. */
  assigneeARIs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Account ARIs of the issue reporters. */
  reporterARIs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Project ARIs the issues reside in. */
  projectARIs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** The status category the issue is currently in. */
  statusCategories?: InputMaybe<Array<SearchIssueStatusCategory>>;
  /** Issue type IDs */
  issueTypeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Label IDs */
  issueLabels?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Account ARI of the issue commenter. */
  commenterARIs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Account ARI of the issue watcher. */
  watcherARIs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
}
export interface SearchJiraProjectFilter {
  projectTypes?: InputMaybe<Array<SearchProjectType>>;
}
export interface SearchLayerDefinition {
  /** Layer Id - eg "L1-optimus" */
  layerId?: InputMaybe<Scalars["String"]["input"]>;
  /** ari or product - eg "ari:cloud:platform::integration/google" "confluence" */
  entity?: InputMaybe<Scalars["String"]["input"]>;
  /** Sub Entity - eg "document" */
  subEntity?: InputMaybe<Scalars["String"]["input"]>;
  /** Experiment ID for shadowing - currently used for Searcher-based layers. */
  shadowId?: InputMaybe<Scalars["String"]["input"]>;
  /** The ID of the experiment the layerId and shadowId are associated with */
  abTestId?: InputMaybe<Scalars["String"]["input"]>;
}
export interface SearchMercuryFilter {
  /** Search for focus areas owned by particular users. The values should be Atlassian Account IDs. */
  owners?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Ids of the focus area types of the result. */
  focusAreaTypeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Ids of the ancestors of the result. */
  ancestorIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
}
export enum SearchProjectType {
  software = "software",
  business = "business",
  service_desk = "service_desk",
  product_discovery = "product_discovery",
}
export enum SearchResultType {
  page = "page",
  blogpost = "blogpost",
  database = "database",
  whiteboard = "whiteboard",
  embed = "embed",
  folder = "folder",
  space = "space",
  attachment = "attachment",
  comment = "comment",
  board = "board",
  dashboard = "dashboard",
  filter = "filter",
  issue = "issue",
  plan = "plan",
  project = "project",
  goal = "goal",
  project_update = "project_update",
  goal_update = "goal_update",
  tag = "tag",
  focus_area = "focus_area",
  focus_area_status_update = "focus_area_status_update",
  question = "question",
  learning = "learning",
  document = "document",
  repository = "repository",
  component = "component",
  presentation = "presentation",
  spreadsheet = "spreadsheet",
  message = "message",
  unrecognised = "unrecognised",
}
export interface SearchThirdPartyFilter {
  /** Search for only entities that have match the date range for the specified field */
  range?: InputMaybe<Array<InputMaybe<SearchThirdPartyRangeFilter>>>;
  /** Search for only entities that have a title that contains the given query */
  titleMatchOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Search for only entities that have the types specified */
  thirdPartyTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search for only entities that have the integration ids specified */
  integrations?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Search for only entities that have the subtypes specified */
  subtypes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Exclude the entities that have the subtypes specified */
  excludeSubtypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Restrict search only to the given ancestors represented by ARIs */
  ancestorAris?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search for only entities that have the containerARIs specified */
  containerAris?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search for only entities that have the containerNames specified */
  containerNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Mapping of each third party product and its subtypes, providerId and integrationId */
  thirdPartyProducts?: InputMaybe<Array<SearchThirdPartyProduct>>;
  /** Search for only entities that have assignee ids specified */
  assignees?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search for text stored under additional text field; for BYOD we can index domain URLs. */
  additionalTexts?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search for only the entities that have createdBy account ids specified */
  createdBy?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search for labels in any thirdparty filter */
  labels?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search for only entities that have the specified container types. */
  containerTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
}
export interface SearchThirdPartyProduct {
  /** The given product's provider id from twg */
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  /** The given product's integration ari */
  integrationId?: InputMaybe<Scalars["String"]["input"]>;
  /** Subtypes mapped to this product for the given query */
  subtypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** ProductKey from frontend code to identify the product for feature gate purposes */
  product?: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates if the product is a smartlink connector, full connector, or both */
  connectorSources?: InputMaybe<Array<Scalars["String"]["input"]>>;
}
export enum SearchThirdPartyRangeField {
  LASTMODIFIED = "LASTMODIFIED",
  CREATED = "CREATED",
}
export interface SearchThirdPartyRangeFilter {
  /** The field to use to calculate the range */
  field: SearchThirdPartyRangeField;
  /** Specify the timestamp that the field should be greater than */
  gt?: InputMaybe<Scalars["String"]["input"]>;
  /** Specify the timestamp that the field should be less than */
  lt?: InputMaybe<Scalars["String"]["input"]>;
}
export interface SearchTrelloFilter {
  /** Whether to search for recent boards */
  isRecentBias?: InputMaybe<Scalars["Boolean"]["input"]>;
}
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_space_SearchConfluenceResultSpace =
  {
    __typename?: "SearchConfluenceResultSpace";
    id: string;
    spaceId: string | null;
    name: string | null;
    key: string | null;
    webUiLink: string | null;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_ancestors_ConfluencePage_links_ConfluencePageLinks =
  {
    __typename?: "ConfluencePageLinks";
    webUi: string | null;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_ancestors_ConfluencePage =
  {
    __typename?: "ConfluencePage";
    title: string | null;
    id: string;
    links: useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_ancestors_ConfluencePage_links_ConfluencePageLinks | null;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji =
  {
    __typename?: "ConfluenceContentTitleEmoji";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_metadata_ConfluenceContentMetadata =
  {
    __typename?: "ConfluenceContentMetadata";
    titleEmojiPublished: useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_metadata_ConfluenceContentMetadata_titleEmojiPublished_ConfluenceContentTitleEmoji | null;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage =
  {
    __typename?: "ConfluencePage";
    id: string;
    type: ConfluenceContentType | null;
    subtype?: ConfluencePageSubType | null;
    ancestors: Array<useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_ancestors_ConfluencePage | null> | null;
    metadata: useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_metadata_ConfluenceContentMetadata | null;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost =
  {
    __typename?: "ConfluenceBlogPost";
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard =
  {
    __typename?: "ConfluenceWhiteboard";
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase =
  {
    __typename?: "ConfluenceDatabase";
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed =
  {
    __typename?: "ConfluenceEmbed";
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder =
  {
    __typename?: "ConfluenceFolder";
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity =

    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceBlogPost
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceWhiteboard
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceDatabase
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceEmbed
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluenceFolder;
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment =
  {
    __typename?: "SearchConfluencePageBlogAttachment";
    entityId: string | null;
    excerpt: string | null;
    isVerified: boolean;
    lastModified: Date | null;
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
    space: useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_space_SearchConfluenceResultSpace | null;
    confluenceEntity: useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity | null;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluenceSpace =
  {
    __typename?: "SearchConfluenceSpace";
    entityId: string | null;
    key: string | null;
    iconPath: string | null;
    webUiLink: string | null;
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchDefaultResult =
  {
    __typename?: "SearchDefaultResult";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasGoal =
  {
    __typename?: "SearchResultAtlasGoal";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasGoalUpdate =
  {
    __typename?: "SearchResultAtlasGoalUpdate";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasProject =
  {
    __typename?: "SearchResultAtlasProject";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasProjectUpdate =
  {
    __typename?: "SearchResultAtlasProjectUpdate";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultBitbucketRepository =
  {
    __typename?: "SearchResultBitbucketRepository";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultCompassComponent =
  {
    __typename?: "SearchResultCompassComponent";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultFederated =
  {
    __typename?: "SearchResultFederated";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGoogleDocument =
  {
    __typename?: "SearchResultGoogleDocument";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGooglePresentation =
  {
    __typename?: "SearchResultGooglePresentation";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGoogleSpreadsheet =
  {
    __typename?: "SearchResultGoogleSpreadsheet";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGraphDocument =
  {
    __typename?: "SearchResultGraphDocument";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraBoard =
  {
    __typename?: "SearchResultJiraBoard";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraDashboard =
  {
    __typename?: "SearchResultJiraDashboard";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraFilter =
  {
    __typename?: "SearchResultJiraFilter";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraIssue =
  {
    __typename?: "SearchResultJiraIssue";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraPlan =
  {
    __typename?: "SearchResultJiraPlan";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraProject =
  {
    __typename?: "SearchResultJiraProject";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMercuryFocusArea =
  {
    __typename?: "SearchResultMercuryFocusArea";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMercuryFocusAreaStatusUpdate =
  {
    __typename?: "SearchResultMercuryFocusAreaStatusUpdate";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMicrosoftDocument =
  {
    __typename?: "SearchResultMicrosoftDocument";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultSlackMessage =
  {
    __typename?: "SearchResultSlackMessage";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultTrelloBoard =
  {
    __typename?: "SearchResultTrelloBoard";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultTrelloCard =
  {
    __typename?: "SearchResultTrelloCard";
    id: string;
    title: string;
    type: SearchResultType;
    url: any;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node =

    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluenceSpace
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchDefaultResult
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasGoal
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasGoalUpdate
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasProject
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultAtlasProjectUpdate
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultBitbucketRepository
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultCompassComponent
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultFederated
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGoogleDocument
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGooglePresentation
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGoogleSpreadsheet
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultGraphDocument
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraBoard
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraDashboard
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraFilter
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraIssue
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraPlan
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultJiraProject
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMercuryFocusArea
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMercuryFocusAreaStatusUpdate
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultMicrosoftDocument
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultSlackMessage
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultTrelloBoard
    | useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchResultTrelloCard;
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge =
  {
    __typename?: "SearchResultItemEdge";
    node: useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node | null;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    endCursor: string | null;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_abTest_SearchAbTest =
  {
    __typename?: "SearchAbTest";
    abTestId: string | null;
    controlId: string | null;
    experimentId: string | null;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection =
  {
    __typename?: "SearchItemConnection";
    totalCount: number | null;
    edges: Array<useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge>;
    pageInfo: useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_pageInfo_PageInfo;
    abTest: useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_abTest_SearchAbTest | null;
  };
export type useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI = {
  __typename?: "SearchQueryAPI";
  search: useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection | null;
};
export type useResultSupplierAdvancedAGGSearchQuery_Query = {
  __typename?: "Query";
  search: useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI | null;
};
export type useResultSupplierAdvancedAGGSearchQueryVariables = Exact<{
  experience: Scalars["String"]["input"];
  analytics?: InputMaybe<SearchAnalyticsInput>;
  query: Scalars["String"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters: SearchFilterInput;
  experimentContext?: InputMaybe<SearchExperimentContextInput>;
  isLivePagesEnabled: Scalars["Boolean"]["input"];
}>;
export type useResultSupplierAdvancedAGGSearchQuery =
  useResultSupplierAdvancedAGGSearchQuery_Query;
